(function(){
  function pad(n){return (n<10?'0':'')+n;}
  function initCd(el){
    if(el.dataset.lvInit)return;el.dataset.lvInit='1';
    var end=el.getAttribute('data-end');if(!end)return;
    var tEnd=new Date(end).getTime();
    if(isNaN(tEnd)){tEnd=new Date(end.replace(/-/g,'/').replace('T',' ')).getTime();}
    if(isNaN(tEnd))return;
    var boxes=el.querySelector('[data-cd-boxes]');var ended=el.querySelector('[data-cd-ended]');
    function set(k,v){var n=el.querySelector('[data-cd="'+k+'"]');if(n)n.textContent=v;}
    function tick(){
      var d=tEnd-Date.now();
      if(d<=0){if(boxes)boxes.style.display='none';if(ended)ended.hidden=false;clearInterval(iv);return;}
      var s=Math.floor(d/1000);
      set('d',pad(Math.floor(s/86400)));set('h',pad(Math.floor((s%86400)/3600)));set('m',pad(Math.floor((s%3600)/60)));set('s',pad(s%60));
    }
    var iv=setInterval(tick,1000);tick();
  }
  function initAll(ctx){(ctx||document).querySelectorAll('[data-lv-countdown]').forEach(initCd);}
  if(document.readyState!=='loading')initAll();else document.addEventListener('DOMContentLoaded',function(){initAll();});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();
